import {
  Announcement,
  Categories,
  ConsultationSlider,
  FeaturedProd,
  Footer,
  HeroBanner,
  ManhoodEdit,
  Navigation,
  Partners,
  PopularCategories,
  Story,
  Testimonials,
  TopDeals,
} from "../components";

const Home = () => {
  return (
    <>
      <Announcement />
      <Navigation />
      <HeroBanner />
      <Categories />
      <ConsultationSlider />
      <TopDeals />
      <FeaturedProd />
      <Story />
      <PopularCategories />
      <Partners />
      <ManhoodEdit />
      <Testimonials />
      <Footer />
    </>
  );
};

export default Home;
